<div class="flex flex-col h-full tk-bg-gray-5">

  <div class="flex items-start pt-4 px-3 tk-bg-gray-5">
    <dsm-search-input class="grow" (searchChanged)="onSearchChanged($event)"
                      label="{{'data-sharing.integration-search' | translate}}"></dsm-search-input>
  </div>
<!--
  <div class="flex flex-col items-center bg-white pt-5 pb-3 text-sm">
    <div class="">
      {{'data-sharing.integration-info' | translate}}
    </div>
    <div>
      <span class="font-semibold mr-1">
        <a href="tel:{{'contact.phone-no-spaces' | translate}}">
          <span class="text-black ml-1">{{'contact.phone' | translate}}</span>
        </a>
      </span>
      <span>{{'labels.or' | translate}}</span>
      <span class="tk-c-blue ml-1">
        <a href="mailto:{{'contact.email' | translate}}?subject={{'contact.email-subject' | translate}}">
          <span class="tk-c-blue">{{'contact.email' | translate}}</span>
        </a>
    </span>
    </div>
  </div> -->

  <div
    [ngClass]="{ 'grid grid-cols-7': filtered.length }"
    class="bg-white overflow-y-auto py-5 mb-12"
    style="padding-bottom: 60px;"
  >
    <div *ngFor="let i of filtered" style="align-items: center; justify-content: center; padding: 15px 20px;" class="flex flex-col tk-border-gray-2 mx-2 my-2 rounded-md cursor-pointer"
         (click)="onOpenWebsite(i.url)">
      <img class="object-cover" [src]="getSrc(i)">
    </div>

    <div *ngIf="filtered?.length === 0" class="flex items-center w-full flex flex-col">
      <app-integrations-empty-state [title]="searchValue" (onClickSubmit$)="onEmptyStateSubmit()"/>
    </div>
  </div>
</div>
